export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";